import type { Service, Product, Testimonial, Stat } from '../types';

export const services: Service[] = [
  {
    id: '1',
    title: 'Serviços Hidráulicos de Campo',
    description: 'Atendimento técnico especializado diretamente em sua obra ou planta industrial. Equipe treinada para diagnóstico e reparo de sistemas hidráulicos complexos.',
    icon: 'ri-tools-line',
    image: '/images/HOME/SERVICOS-DE-CAMPO/SERVICOS-CAMPO.webp',
  },
  {
    id: '2',
    title: 'Manutenção Industrial',
    description: 'Programas preventivos e corretivos de manutenção hidráulica para maximizar a vida útil dos seus equipamentos e minimizar paradas não planejadas.',
    icon: 'ri-settings-3-line',
    image: '/images/HOME/SERVICOS-DE-CAMPO/SERVICOS-CAMPO.webp',
  },
  {
    id: '3',
    title: 'Reparo em Oficina',
    description: 'Oficina equipada com tecnologia de ponta para reparo, recuperação e teste de cilindros, bombas, motores e componentes hidráulicos de todas as marcas.',
    icon: 'ri-hammer-line',
    image: '/images/HOME/OFICINA-ESPECIALIZADA/OFICINA-ESPECIALIZADA.webp',
  },
  {
    id: '4',
    title: 'Suporte Técnico Especializado',
    description: 'Consultoria técnica e suporte para projetos hidráulicos, seleção de componentes, análise de falhas e otimização de sistemas hidráulicos industriais.',
    icon: 'ri-file-list-3-line',
    image: '/images/HOME/SERVICOS-DE-CAMPO/SERVICOS-CAMPO.webp',
  },
];

export const products: Product[] = [
  {
    id: '1',
    name: 'Mangueiras Hidráulicas',
    category: 'DURAFLOW',
    description: 'Mangueiras de alta pressão com reforço em aço, disponíveis em diversas pressões e diâmetros.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANGUEIRAS-HIDRAULICAS/CARD/MANGUEIRAS-HIDRAULICAS.webp',
    route: '/mangueiras-hidraulicas',
  },
  {
    id: '2',
    name: 'Bombas Hidráulicas',
    category: 'DURAFLOW',
    description: 'Bombas de pistão, engrenagem e palheta para aplicações industriais e móveis.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/BOMBAS-HIDRAULICAS/CARD/BOMBAS-HIDRAULICAS.webp',
    route: '/bombas-hidraulicas',
  },
  {
    id: '3',
    name: 'Motores Hidráulicos',
    category: 'DURAFLOW',
    description: 'Motores de pistão axial e radial para alta torque e baixa velocidade.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MOTORES-HIDRAULICOS/CARD/MOTORES-HIDRAULICOS.webp',
    route: '/motores-hidraulicos',
  },
  {
    id: '4',
    name: 'Cilindros Hidráulicos',
    category: 'DURAFLOW',
    description: 'Cilindros customizados e padrão para diversas aplicações industriais.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/CILINDROS-HIDRAULICOS/CARD/CILINDROS-HIDRAULICOS.webp',
    route: '/cilindros-hidraulicos',
  },
  {
    id: '5',
    name: 'Válvulas Hidráulicas',
    category: 'DURAFLOW',
    description: 'Válvulas direcionais, reguladoras de pressão e fluxo de alta precisão.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-HIDRAULICAS/CARD/VALVULAS-HIDRAULICAS.webp',
    route: '/valvulas-hidraulicas',
  },
  {
    id: '9',
    name: 'Acumuladores Hidráulicos',
    category: 'DURAFLOW',
    description: 'Acumuladores de bexiga, pistão e diafragma para armazenamento de energia e estabilização de sistemas hidráulicos.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/ACUMULADORES-HIDRAULICOS/CARD/ACUMULADOR-HIDRAULICO.webp',
    route: '/acumuladores-hidraulicos',
  },
  {
    id: '6',
    name: 'Manômetros e Medidores',
    category: 'DURAFLOW',
    description: 'Manômetros digitais e analógicos para monitoramento de pressão em sistemas hidráulicos.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANOMETROS-E-MEDIDORES/CARD/MANOMETROS-E-MEDIDORES.webp',
    route: '/manometros-medidores',
  },
  {
    id: '7',
    name: 'Válvulas de Controle',
    category: 'DURAFLOW',
    description: 'Solenoides, proporcionais e servo-válvulas para controle preciso.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-DE-CONTROLE/CARD/VALVULAS-DE-CONTROLE.webp',
    route: '/valvulas-de-controle',
  },
  {
    id: '8',
    name: 'Acessórios e Conexões',
    category: 'DURAFLOW',
    description: 'Conexões, adaptadores, acoplamentos rápidos e acessórios hidráulicos.',
    image: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/ACESSORIOS-E-CONEXOES/CARD/ACESSORIOS-E-CONEXOES.webp',
    route: '/acessorios-conexoes',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    quote: 'A Pilar já atua conosco em todas as paradas gerais, sempre com uma entrega espetacular.',
    author: 'Rômulo',
    role: 'Cliente industrial',
    company: 'Setor de Papel e Celulose',
    image: '/images/HOME/DEPOIMENTOS/testemunho-romulo.jpg',
  },
  {
    id: '2',
    quote: 'Encerramos o apoio técnico com gratidão pelo conhecimento compartilhado e pelo comprometimento das equipes envolvidas. O suporte da Pilar, com mão de obra qualificada, foi essencial para entregar as máquinas em operação.',
    author: 'William',
    role: 'Cliente industrial',
    company: 'Unidade de Papel e Celulose',
    image: '/images/HOME/DEPOIMENTOS/testemunho-william.jpg',
  },
];

export const stats: Stat[] = [
  { value: '18+', label: 'Anos de Experiência' },
  { value: '500+', label: 'Clientes Atendidos' },
  { value: '15.000+', label: 'Serviços Realizados' },
  { value: '98%', label: 'Taxa de Satisfação' },
];

export const companyInfo = {
  name: 'Grupo Pilar',
  tagline: 'Excelência em Hidráulica Industrial',
  description: 'Há mais de 18 anos, a Grupo Pilar é referência em serviços hidráulicos no Brasil. Nossa equipe de engenheiros e técnicos especializados atende desde pequenas manutenções até grandes projetos industriais, sempre com foco em qualidade, segurança e eficiência.',
  address: 'Rua Perobas, 116 - Coqueiral',
  city: 'Aracruz',
  state: 'ES',
  zip: '29190-000',
  phone: '',
  whatsapp: '+55 (27) 99309-2922',
  email: 'contato@pilar-aracruz.com.br',
};